import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import Page from '../page';
import forDevice from '../../hoc/for-device';
import styles from './post-page-layout.scss';

const PostPageLayoutMobile = ({ children, ...otherProps }) =>
  <Page noSpacing {...otherProps}>
    {children}
  </Page>;

PostPageLayoutMobile.propTypes = {
  children: PropTypes.node,
};

const PostPageLayoutDesktop = ({ children, className, ...otherProps }) => {
  return (
    <Page className={classNames(styles.container, className)} {...otherProps}>
      {children}
    </Page>
  );
};

PostPageLayoutDesktop.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

export default forDevice(PostPageLayoutMobile, PostPageLayoutDesktop);



// WEBPACK FOOTER //
// ./app/components/post-page-layout/post-page-layout.js